import { Box, Tooltip } from '@freighthub/silhouette-core'
import { Component, FC } from 'react'
import { useI18n } from 'utils/localisation'

import { TActor, TFreightie } from '../../Actors'
import { Avatar } from '../../avatars/Avatar'
import { INITIALS_AVATAR, TAvatarType, THUMBNAIL_AVATAR } from '../../avatars/AvatarType'
import { IAvatarProps } from '../../avatars/IAvatarProps'
import { SubscriptionAvatar } from '../../avatars/SubscriptionAvatar'
import { TIdType, USER_ID } from '../SubscriptionModel'

export const moreMembersTestId = 'more-subscription-members'

export interface IMemberItemProps {
  actor: TActor
  idType: TIdType
  isDisabled: boolean
  removeSubscriber: (id: string, idType: TIdType) => void
  showDisplayName?: boolean
  userType: IAvatarProps['userType']
}

export class MemberItem extends Component<IMemberItemProps> {
  constructor(props) {
    super(props)
    this.getThumbnailUrl = this.getThumbnailUrl.bind(this)
  }

  getThumbnailUrl(actor, idType) {
    return idType === USER_ID ? '' : (actor as TFreightie).thumbnailUrl
  }

  render() {
    const { actor, idType, isDisabled, showDisplayName, userType } = this.props
    const thumbnailUrl = this.getThumbnailUrl(actor, idType)
    const isShowDisplayName = showDisplayName ?? true

    return (
      <SubscriptionAvatar
        avatar={thumbnailUrl || actor.initials}
        avatarType={(thumbnailUrl ? THUMBNAIL_AVATAR : INITIALS_AVATAR) as TAvatarType}
        onClick={() => this.props.removeSubscriber(actor._id, idType)}
        disabled={isDisabled}
        hoverText={isShowDisplayName ? actor.email : actor.name}
        subscriberName={actor.name}
        displayName={isShowDisplayName}
        userType={userType}
      />
    )
  }
}

type IMoreMembersProps = {
  moreNumber: number
}

export const MoreMembers: FC<IMoreMembersProps> = ({ moreNumber }) => {
  const { translate } = useI18n()

  return (
    <Tooltip title={translate('more-members-members_count', { count: moreNumber })}>
      <Box component="span" mr={0.5}>
        <Avatar data-testid={moreMembersTestId} avatar={`+${moreNumber}`} avatarType={INITIALS_AVATAR} size="large" />
      </Box>
    </Tooltip>
  )
}
